import { render, staticRenderFns } from "./TripleMedia.vue?vue&type=template&id=36e75b94&"
import script from "./TripleMedia.vue?vue&type=script&lang=js&"
export * from "./TripleMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports